/// <amd-module name="SuiteCommerce.Blog.LatestPosts.Slide.Collection"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.Blog.LatestPosts.Slide.Collection", ["require", "exports", "SuiteCommerce.Blog.LatestPosts.Slide.Model.ts", "Backbone"], function (require, exports, LatestPosts_Slide_Model_1, Backbone_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LatestPostsSlideCollection = /** @class */ (function (_super) {
        __extends(LatestPostsSlideCollection, _super);
        function LatestPostsSlideCollection() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.model = LatestPosts_Slide_Model_1.LatestPostsSlideModel;
            return _this;
        }
        return LatestPostsSlideCollection;
    }(Backbone_1.Collection));
    exports.LatestPostsSlideCollection = LatestPostsSlideCollection;
});
